// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-salepage-action .v-list-item__subtitle[data-v-99605a24] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  color: #6B6B6B;\n}\n.card-style[data-v-99605a24] {\n  background: #EAEEF5;\n  border: 1px dashed #D5D5D5;\n  box-sizing: border-box;\n  border-radius: 2px;\n}\n.font-style[data-v-99605a24] {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #A2AAB8;\n}\n", ""]);
// Exports
module.exports = exports;
